;(function () {
  const initProductCarousels = () => {
    document.querySelectorAll('.product-carousel-section').forEach((section) => {
      if (section.classList.contains('slider_started')) return

      const carousel = section.querySelector('.swiper-carousel')
      const wrapper = section.querySelector('.product-carousel__wrapper')
      const slides = section.querySelectorAll('.swiper-slide')
      const nextButton = section.querySelector('.swiper-button-next__prod')
      const prevButton = section.querySelector('.swiper-button-prev__prod')

      if (!carousel || !wrapper || !slides.length) return

      section.classList.add('slider_started')

      const sectionId = section.id
      const slidesCount = parseFloat(wrapper.dataset.count || '4') + 0.1
      const shouldLoop = carousel.dataset.loop === 'true'

      new Swiper(`#${sectionId} .swiper-carousel`, {
        centeredSlides: false,
        slidesPerView: 1.1,
        waitForTransition: false,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        loop: shouldLoop,
        preloadImages: true,
        allowTouchMove: true,
        spaceBetween: 4,

        navigation: {
          nextEl: `#${sectionId} .swiper-button-next__prod`,
          prevEl: `#${sectionId} .swiper-button-prev__prod`,
        },

        breakpoints: {
          990: {
            slidesPerView: 2.1,
          },
          1200: {
            slidesPerView: 3.1,
          },
          1360: {
            slidesPerView: slidesCount,
          },
        },

        on: {
          slideChange() {
            if (this.activeIndex === 0) {
              slides.forEach((slide) => {
                slide.classList.remove('slide_change-postion')
              })

              carousel.classList.add('carousel_change-postion_next')
              carousel.classList.remove(
                'carousel_change-postion_prev',
                'carousel_change-postion_next-2'
              )

              this.update()
              return
            }

            if (this.activeIndex > this.previousIndex) {
              carousel.classList.remove(
                'carousel_change-postion_next',
                'carousel_change-postion_next-2'
              )
              carousel.classList.add('carousel_change-postion_prev')

              slides.forEach((slide) => {
                if (nextButton && nextButton.classList.contains('swiper-button-disabled')) {
                  slide.classList.remove('slide_change-postion')
                } else {
                  slide.classList.add('slide_change-postion')
                }
              })
            } else {
              carousel.classList.add('carousel_change-postion_next-2')
              carousel.classList.remove('carousel_change-postion_prev')

              slides.forEach((slide) => {
                slide.classList.remove('slide_change-postion')
              })
            }

            this.update()
          },
        },
      })

      initFloatingProductLink(section)
    })
  }

  const initFloatingProductLink = (section) => {
    if (window.innerWidth <= 990) return

    const floatingLink = section.querySelector('.button--with-underline--container')
    const cards = section.querySelectorAll('[data-carousel-link-enabled="true"]')

    if (!floatingLink || !cards.length) return

    let isAttached = false

    const followMouse = (event) => {
      floatingLink.style.left = `${event.pageX}px`
      floatingLink.style.top = `${event.pageY + 30}px`
    }

    const showFloatingLink = () => {
      if (isAttached) return

      isAttached = true
      floatingLink.style.display = 'block'
      document.addEventListener('pointermove', followMouse)
    }

    const hideFloatingLink = () => {
      isAttached = false
      floatingLink.style.display = ''
      document.removeEventListener('pointermove', followMouse)
    }

    cards.forEach((card) => {
      card.addEventListener('pointerenter', showFloatingLink)
      card.addEventListener('pointerleave', hideFloatingLink)
    })
  }

  document.addEventListener('DOMContentLoaded', initProductCarousels)

  document.addEventListener('shopify:section:load', function () {
    initProductCarousels()
  })

  initProductCarousels()
})()